import React from "react";
import { NavLink as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, Button, ListItem, Typography } from "@mui/material";
import { styled } from "@mui/material";

const CustomButton = styled(Button)(({ theme }) => ({
	fontWeight: theme.typography.fontWeightMedium,
	justifyContent: "flex-start",
	letterSpacing: 0,
	padding: "10px 15px",
	textTransform: "none",
	width: "100%",
	"&.active": {
		backgroundColor: theme.palette.admin.primary,
		color: "white",
		"& .title": {
			color: "white",
			fontWeight: "700",
		},
		"& $icon": {
			color: "white",
		},
	},
}));

const NavItem = ({ className, href, icon: Icon, title, onClose, ...rest }) => {
	return (
		<ListItem disableGutters {...rest}>
			<CustomButton component={RouterLink} to={href} onClick={onClose}>
				<Icon size="20" style={{ paddingRight: 15 }} />

				<Typography variant="body1" className={"title"}>
					{title}
				</Typography>
			</CustomButton>
		</ListItem>
	);
};

NavItem.propTypes = {
	className: PropTypes.string,
	href: PropTypes.string,
	icon: PropTypes.elementType,
	title: PropTypes.string,
};

export default NavItem;
